import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';
import { DataSyncServiceComponent } from './DataSyncServiceComponent';
export const DataSyncReconnectionConfig = {
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED],
  serviceComponent: DataSyncServiceComponent
};